<div class="monitor-layout">
    <div class="monitor-container">

        <div class="unified-header">
            <div class="header-left">
                <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
                    <mat-icon>arrow_back</mat-icon>
                </button>
                <h1 class="page-title">
                    <mat-icon class="title-icon">dashboard</mat-icon>
                    Dashboard de Facturas
                </h1>
            </div>
        </div>

        <!-- [MODIFICACIÓN] Usamos isDataLoadingSignal (solo API) para el bloqueo principal -->
        @if (isDataLoadingSignal()) {
        <div class="spinner-container">
            <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        </div>
        } @else {

        <!-- Collapsible Filters Panel - Siempre visible -->
        <mat-expansion-panel class="filters-panel" [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <mat-icon>filter_list</mat-icon>
                        <span>Filtros</span>
                        <!-- Spinner local alineado inmediatamente después de "Filtros" -->
                        @if (isComputingSignal()) {
                            <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner" style="margin-left: 2px;"></mat-progress-spinner>
                        }
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <span class="spacer"></span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="filters-row">
                <!-- Emisor Filter -->
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Emisor</mat-label>
                    <input type="text" matInput [(ngModel)]="emisorFilter" [matAutocomplete]="autoEmisor"
                        (ngModelChange)="onFilterChange()">
                    <mat-autocomplete #autoEmisor="matAutocomplete">
                        @for (emisor of filteredEmisores; track $index) {
                        <mat-option [value]="emisor.viewValue">{{ emisor.viewValue }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Client Filter -->
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Cliente</mat-label>
                    <input type="text" matInput [(ngModel)]="clientFilter" [matAutocomplete]="auto"
                        (ngModelChange)="onFilterChange()">
                    <mat-autocomplete #auto="matAutocomplete">
                        @for (client of filteredClients; track $index) {
                        <mat-option [value]="client.viewValue">{{ client.viewValue }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <!-- Emission Date Filter -->
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic"
                    style="width: 240px; min-width: 240px;">
                    <mat-label>Fecha de Emisión</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Desde" [(ngModel)]="emisionFilter.begin" (ngModelChange)="onEmisionStartDateChange()">
                        <input matEndDate placeholder="Hasta" [(ngModel)]="emisionFilter.end" (ngModelChange)="onEmisionEndDateChange()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <!-- Due Date Filter -->
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic"
                    style="width: 240px; min-width: 240px;">
                    <mat-label>Fecha de Vencimiento</mat-label>
                    <mat-date-range-input [rangePicker]="Vpicker">
                        <input matStartDate placeholder="Desde" [(ngModel)]="dueFilter.begin" (ngModelChange)="onDueStartDateChange()">
                        <input matEndDate placeholder="Hasta" [(ngModel)]="dueFilter.end" (ngModelChange)="onDueEndDateChange()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="Vpicker"></mat-datepicker-toggle>
                    <mat-date-range-picker #Vpicker></mat-date-range-picker>
                </mat-form-field>

                <!-- Action Buttons -->
                <div class="filter-actions-inline">
                    <button mat-icon-button color="warn" (click)="reloadData()" [disabled]="cleanFilter"
                        matTooltip="Limpiar Filtros">
                        <mat-icon>filter_alt_off</mat-icon>
                    </button>

                    <!-- Botón de Refresco (Nueva Funcionalidad) -->
                    <button mat-icon-button color="accent" (click)="forceRefresh()" matTooltip="Refrescar Datos">
                        <mat-icon>refresh</mat-icon>
                    </button>

                    <div class="divider-vertical" style="width: 1px; height: 24px; background: #e0e0e0; margin: 0 4px;"></div>

                    <!-- Iconos cambiados a 'file_download' y 'cloud_download' -->
                    <button mat-icon-button color="accent" (click)="download()" matTooltip="Descargar Reporte General">
                        <mat-icon>file_download</mat-icon>
                    </button>

                    <button mat-icon-button color="primary"
                        (click)="downloadEmisorReport(emisionFilter.begin!, emisionFilter.end!)"
                        [disabled]="!emisionFilter.begin || !emisionFilter.end" matTooltip="Descargar Reporte Emisor">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                </div>
            </div>
        </mat-expansion-panel>

        @if (uiData.length > 0) {
        <h1 class="usage-title">Estados de Facturas</h1>

        <div class="usage-bar">
            @for (item of uiData; track $index) {
            <div class="usage-segment" [style.width.%]="item.percent" [style.background]="item.stage"
                [title]="item.label + ':' + item.percent + '%'">
                <span class="label">{{ item.percent }}%</span>
            </div>
            }
        </div>
        <div class="usage-legend">
            @for (item of uiData; track $index) {
            <div class="legend-item">
                <span class="dot" [style.background]="item.stage"></span>
                <span class="legend-label">{{ item.status }}</span>
            </div>
            }
        </div>

        <div class="dashboard-grid">
            @for (data of uiData; track $index){
            <mat-card class="status-card status-{{ data.color }}" (click)="onStatusClick(data)">
                <div class="card-header">
                    <div class="order-number-circle">{{ $index + 1 }}</div>
                    <span class="status-title">{{ data.status }}</span>
                </div>

                <div class="card-content">
                    <h2>{{ data.count }}/{{filterFacturas.length}}</h2>
                    <mat-progress-bar [color]="data.color" mode="determinate" [value]="(data.count / total) * 100">
                    </mat-progress-bar>
                </div>

                @if(data.statuses) {
                <div class="card-breakdown">
                    @for(subStatus of getSubStatusCounts(data.statuses); track subStatus.name) {
                    <span class="sub-status">{{ subStatus.name }}: <strong>{{ subStatus.count }}</strong></span>
                    }
                </div>
                }
            </mat-card>
            }
        </div>
        } @else {
        <div class="no-data-message">
            <p>No se encontraron facturas con los filtros aplicados</p>
            <button mat-raised-button color="primary" (click)="reloadData();">Recargar</button>
        </div>
        }
        }
    </div>
</div>